import { sendUTMsAsCustomTags, setUserTypeTag } from '@/utils/clarity-tags';

import Clarity from '@microsoft/clarity';
import ReactPixel from 'react-facebook-pixel';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const usePageTracking = () => {
  let location;
  try {
    location = useLocation();
  } catch (error) {
    console.warn('useLocation failed, skipping page tracking:', error);
    return;
  }

  const { loggedIn } = useSelector((state) => state.auth || {});
  const getUTM = (k) => sessionStorage.getItem(k) || undefined;

  useEffect(() => {
    if (location.pathname.indexOf('transaction') === -1 && location.pathname.indexOf('payment') === -1) {
      ReactPixel.pageView();

      sendUTMsAsCustomTags();

      setUserTypeTag(loggedIn);

      try {
        if (typeof window !== 'undefined' && window.clarity) {
          window.clarity('event', `page_view_${location.pathname.replace(/\//g, '_')}`, {
            page_path: location.pathname,
            utm_source: getUTM('utm_source'),
            utm_medium: getUTM('utm_medium'),
            utm_campaign: getUTM('utm_campaign'),
            utm_content: getUTM('utm_content'),
            fbclid: getUTM('fbclid')
          });
        } else if (Clarity && typeof Clarity.event === 'function') {
          Clarity.event(`page_view_${location.pathname.replace(/\//g, '_')}`, {
            page_path: location.pathname,
            utm_source: getUTM('utm_source'),
            utm_medium: getUTM('utm_medium'),
            utm_campaign: getUTM('utm_campaign'),
            utm_content: getUTM('utm_content'),
            fbclid: getUTM('fbclid')
          });
        }
      } catch (error) {
        console.warn('Clarity tracking failed:', error);
      }
    }
  }, [location]);
};

export default usePageTracking;
